// Shared constants for the four-mode topology page.
// KNOWN_DEVICES is a copy of the registry in AISentry.jsx — do not import from there.

export const KNOWN_DEVICES = {
  // lab-dc-prime (Alienware) — legacy OT sandbox factory PLCs
  '192.168.1.70':  { name: 'Mitsubishi FX5U',        role: 'PLC',     vendor: 'Mitsubishi' },
  '192.168.1.71':  { name: 'Omron NX1P2',            role: 'PLC',     vendor: 'Omron' },
  '192.168.1.72':  { name: 'Beckhoff CX5130',        role: 'PLC',     vendor: 'Beckhoff' },
  '192.168.1.73':  { name: 'ABB PM5650',             role: 'PLC',     vendor: 'ABB' },
  '192.168.1.75':  { name: 'Ignition HMI',           role: 'HMI',     vendor: 'Inductive Automation' },
  // site-atlanta / site-frankfurt / site-singapore — substation IEDs (10.x.1.x)
  '10.10.1.70':  { name: 'SEL-411L Line Relay',    role: 'IED',     vendor: 'SEL' },
  '10.10.1.71':  { name: 'SEL-751 Feeder Relay',   role: 'IED',     vendor: 'SEL' },
  '10.10.1.72':  { name: 'GE L90 Line Diff',       role: 'IED',     vendor: 'GE' },
  '10.10.1.73':  { name: 'ABB REL670 Distance',    role: 'IED',     vendor: 'ABB' },
  '10.10.1.74':  { name: 'Siemens SICAM RTU',      role: 'RTU',     vendor: 'Siemens' },
  '10.10.1.75':  { name: 'IEC 61850 Gateway',      role: 'Gateway', vendor: 'Moxa' },
  '10.10.1.76':  { name: 'SCADA Master',           role: 'HMI',     vendor: 'OSIsoft' },
  '10.20.1.70':  { name: 'SEL-411L Line Relay',    role: 'IED',     vendor: 'SEL' },
  '10.20.1.71':  { name: 'SEL-751 Feeder Relay',   role: 'IED',     vendor: 'SEL' },
  '10.20.1.72':  { name: 'GE L90 Line Diff',       role: 'IED',     vendor: 'GE' },
  '10.20.1.73':  { name: 'ABB REL670 Distance',    role: 'IED',     vendor: 'ABB' },
  '10.20.1.74':  { name: 'Siemens SICAM RTU',      role: 'RTU',     vendor: 'Siemens' },
  '10.20.1.75':  { name: 'IEC 61850 Gateway',      role: 'Gateway', vendor: 'Moxa' },
  '10.20.1.76':  { name: 'SCADA Master',           role: 'HMI',     vendor: 'OSIsoft' },
  '10.30.1.70':  { name: 'SEL-411L Line Relay',    role: 'IED',     vendor: 'SEL' },
  '10.30.1.71':  { name: 'SEL-751 Feeder Relay',   role: 'IED',     vendor: 'SEL' },
  '10.30.1.72':  { name: 'GE L90 Line Diff',       role: 'IED',     vendor: 'GE' },
  '10.30.1.73':  { name: 'ABB REL670 Distance',    role: 'IED',     vendor: 'ABB' },
  '10.30.1.74':  { name: 'Siemens SICAM RTU',      role: 'RTU',     vendor: 'Siemens' },
  '10.30.1.75':  { name: 'IEC 61850 Gateway',      role: 'Gateway', vendor: 'Moxa' },
  '10.30.1.76':  { name: 'SCADA Master',           role: 'HMI',     vendor: 'OSIsoft' },
  // site-dallas-dc — factory PLCs (mirrors lab-dc-prime / Raspberry Pi layout)
  '10.40.1.70':  { name: 'Mitsubishi FX5U',        role: 'PLC',     vendor: 'Mitsubishi' },
  '10.40.1.71':  { name: 'Omron NX1P2',            role: 'PLC',     vendor: 'Omron' },
  '10.40.1.72':  { name: 'Beckhoff CX5130',        role: 'PLC',     vendor: 'Beckhoff' },
  '10.40.1.73':  { name: 'ABB PM5650',             role: 'PLC',     vendor: 'ABB' },
  '10.40.1.75':  { name: 'Ignition HMI',           role: 'HMI',     vendor: 'Inductive Automation' },
};

export const EDGE_AGENT_IP = '192.168.1.214';
export const EDGE_AGENT_NAME = 'Celerway Edge Agent';

export const PROTOCOL_COLORS = {
  dnp3:    '#3B82F6',  // blue
  mms:     '#14B8A6',  // teal
  goose:   '#EAB308',  // gold
  modbus:  '#10B981',  // green
  snmp:    '#8B5CF6',  // purple
  bacnet:  '#F97316',  // orange
  it:      '#EF4444',  // red
};

export const ROLE_COLORS = {
  PLC:       '#22D3EE',  // cyan
  IED:       '#818CF8',  // indigo
  HMI:       '#F472B6',  // pink
  Historian: '#A3E635',  // lime
  Gateway:   '#FB923C',  // orange
  RTU:       '#34D399',  // emerald
};

export const SEVERITY_COLORS = {
  Critical:      '#EF4444',
  High:          '#F97316',
  Medium:        '#EAB308',
  Low:           '#6B7280',
  Informational: '#475569',
};

// ─── Timestamp utility ───────────────────────────────────────────────────────
// Always format in UTC so the UI matches agent log timestamps.
export function fmtUtc(ts) {
  if (!ts) return '—';
  const d = new Date(ts.endsWith('Z') ? ts : ts + 'Z');
  return d.toLocaleTimeString(undefined, { timeZone: 'UTC', hour12: false }) + ' UTC';
}

// ─── Policy plain-language names ─────────────────────────────────────────────
// Maps internal policy names (shown verbatim in the DB) to user-facing labels.
// Raw policy IDs are preserved in the detail card for the policy library link.
export const POLICY_PLAIN_NAMES = {
  'OT Visibility — Foundational Traffic Log': 'Modbus traffic monitored',
  'Block Unauthorized Modbus Access':          'Blocked: unauthorized Modbus',
  'PLC Lateral Movement Detection':            'Lateral movement detected',
  'DNP3 Unauthorized Write':                   'Blocked: unauthorized DNP3 write',
  'DNP3 Direct Operate':                       'DNP3 direct operate command',
  'DNP3 Cold Restart':                         'DNP3 device restart command',
  'DNP3 CROB Relay Trip':                      'Relay trip command detected',
  'Unauthorized SNMP Access':                  'SNMP from unregistered host',
  'SNMP Default Community':                    'Insecure SNMP community string',
  'SNMPv1 Insecure Protocol':                  'Insecure SNMP version (v1)',
  'BACnet WhoIs Discovery':                    'BACnet device scan',
  'BACnet ReadProperty Unauthorized':          'Unauthorized BACnet read',
  'BACnet WriteProperty':                      'BACnet setpoint change',
  'MMS Unauthorized Write':                    'Blocked: unauthorized MMS write',
  'MMS Write to Relay':                        'MMS write to protection relay',
  'MMS Read Logged':                           'MMS read logged',
  'GOOSE State Change':                        'GOOSE protection state change',
};

export function plainPolicyName(raw) {
  return POLICY_PLAIN_NAMES[raw] || raw;
}

// Native subnet prefix per site — used to filter out cross-sniffed traffic
// when a promiscuous agent (e.g. Alienware) sees devices from other sites.
export const SITE_NATIVE_PREFIX = {
  'lab-dc-prime':    '192.168.1.',
  'site-atlanta':    '10.10.1.',
  'site-frankfurt':  '10.20.1.',
  'site-singapore':  '10.30.1.',
  'site-dallas-dc':  '10.40.1.',
};

// Substation IPs that participate in the GOOSE protection domain
export const SUBSTATION_IPS = [
  '192.168.1.100',
  '192.168.1.101',
  '192.168.1.102',
  '192.168.1.103',
  '192.168.1.104',
  '192.168.1.105',
];
